import React from "react";

import TodoList from './components/TodoList';
import "./App.css";

function App() {
  return (
    <div>
      <TodoList />
    </div>
  );
}

export default App;
